import HigherOrderSequencer from "higherorder/HigherOrderSequencer.js";

export default superclass => class extends superclass {
    higherOrderSequencer = new HigherOrderSequencer(this);

    applyHigherOrderSequencing(currentStep) {
        let wasRolling = this.higherOrderSequencer.wasRolling;
        let {isRolling, isNewRoll, modules} = this.higherOrderSequencer.isRolling();
        if (isRolling !== wasRolling || isNewRoll) {
            let step = this.higherOrderSequencer.getStepForModule(currentStep);
            this.setSequenceRolling(
                isRolling,
                undefined,
                true,
                step,
                isNewRoll);

            for (let module of this.subSequences) {
                if (!isRolling) {
                    module.higherRolling = undefined;
                    continue;
                }
                module.higherRolling = modules.includes(module);
            }
        }
    }
}
